import { render, staticRenderFns } from "./NotifyList.vue?vue&type=template&id=77868fc5"
import script from "./NotifyList.vue?vue&type=script&lang=js"
export * from "./NotifyList.vue?vue&type=script&lang=js"
import style0 from "./NotifyList.vue?vue&type=style&index=0&id=77868fc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports